import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=2fcab946&scoped=true"
import script from "./FormDialog.vue?vue&type=script&lang=ts"
export * from "./FormDialog.vue?vue&type=script&lang=ts"
import style0 from "./FormDialog.vue?vue&type=style&index=0&id=2fcab946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcab946",
  null
  
)

export default component.exports